module.exports = __webpack_public_path__ + "static/media/2.0a1cbc91.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格选中态/2.png
// module id = 1274
// module chunks = 0